import { QueryData } from '../../query-data';

export const setSelectRelation = (q: QueryData) => {
  q.selectRelation = true;
};
